const position = (sign) => {
	switch (sign) {
	case 'aries':				return 1
	case 'taurus':			return 2
	case 'gemini':			return 3
	case 'cancer':			return 4
	case 'leo':					return 5
	case 'virgo':				return 6
	case 'libra':				return 7
	case 'scorpio':			return 8
	case 'sagittarius':	return 9
	case 'capricorn':		return 10
	case 'aquarius':		return 11
	case 'pisces':			return 12
	default:						return null
	}
}

const aspect = (sign1, sign2) => {
	const position1 = position(sign1)
	const position2 = position(sign2)
	const opposition = position2 + 6 > 12 ? (position2 + 6) % 12 : position2 + 6
	const trine1 = position2 + 4 > 12 ? (position2 + 4) % 12 : position2 + 4
	const trine2 = position2 + 8 > 12 ? (position2 + 8) % 12 : position2 + 8
	const square1 = position2 + 3 > 12 ? (position2 + 3) % 12 : position2 + 3
	const square2 = position2 + 9 > 12 ? (position2 + 9) % 12 : position2 + 9
	const semisextile1 = position2 + 1 > 12 ? (position2 + 1) % 12 : position2 + 1
	const semisextile2 = position2 + 11 > 12 ? (position2 + 11) % 12 : position2 + 11
	const sextile1 = position2 + 2 > 12 ? (position2 + 2) % 12 : position2 + 2
	const sextile2 = position2 + 10 > 12 ? (position2 + 10) % 12 : position2 + 10
	const inconjunct1 = position2 + 5 > 12 ? (position2 + 5) % 12 : position2 + 5
	const inconjunct2 = position2 + 7 > 12 ? (position2 + 7) % 12 : position2 + 7
	if (position1 === position2)																	return 'conjunction'
	if (position1 === trine1 || position1 === trine2)							return 'trine'
	if (position1 === sextile1 || position1 === sextile2)					return 'sextile'
	if (position1 === inconjunct1 || position1 === inconjunct2)		return 'quincunx'
	if (position1 === semisextile1 || position1 === semisextile2)	return 'semisextile'
	if (position1 === opposition)																	return 'opposition'
	if (position1 === square1 || position1 === square2)						return 'square'
	return null
}

export default (userSign, contactSign) => {
	const colorScale = {
		conjunction: 'purple',
		trine: 'blue',
		sextile: 'turquoise',
		quincunx: 'green',
		semisextile: 'yellow',
		opposition: 'orange',
		square: 'red'
	}
	return { aspect: aspect(userSign, contactSign), color: colorScale[aspect(userSign, contactSign)] }
}



// WEBPACK FOOTER //
// ./src/functions/relationship.js